import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandler } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PagoSolicitudReembolso, Respuesta } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  url = environment.api;
  constructor(private http: HttpClient, private errorHandler: ErrorHandler) {}


  login(email: string, tkn: string): Observable<Respuesta> {
    return this.http.post<Respuesta>(`${this.url}Login`, null).pipe(
      map((response: Respuesta) => response),
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al iniciar sesión'));
      })
    );
  }
}
